import { CSSProperties } from 'react'

interface Props {
  style?: CSSProperties
}

export const PremiumInfo = ({ style }: Props) => {
  return (
    <div className="premium-info" style={style}>
      <div className="icon">🌟</div> Доступно только на премиум аккаунте
    </div>
  )
}
